import request from '@/util/request';
import qs from 'qs';

//房产模糊搜索
export const loadRoomFuzzy = (params, options) =>
  request.get('/api/propertyCharges/household/getSearch', Object.assign({}, options, { params }));
//房产树一级节点
export const loadRoomTree1 = (params, options) =>
  request.get(
    '/api/propertyCharges/household/getVisibleTree',
    Object.assign({}, options, { params })
  );
//房产树子节点
export const loadRoomTree2 = (params, options) =>
  request.get(
    '/api/propertyCharges/household/getChildrenNode',
    Object.assign({}, options, { params })
  );
